import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AnalyticsChoice from '../common/AnalyticsChoice';

import BannerCarousel from '../common/BannerCarousel';
import { getPageTypeFromPath } from '../../lib/gaParams';
import '../../styles/Layout.css';

const Layout = () => {
  const location = useLocation();
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const analyticsTrigger = useRef(null);
  const pageType = getPageTypeFromPath(location.pathname);

  // 페이지 전환 시 스크롤을 상단으로 이동
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        minHeight: '100svh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: { xs: '56px', md: '60px' }, // Header 높이만큼 상단 여백

        boxSizing: 'border-box',
      }}
    >
      {/* 헤더 */}
      <Header />

      {/* 배너 */}
      <BannerCarousel pageType={pageType} />

      {/* 라우팅된 페이지 */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minHeight: {
            xs: 'calc(100svh - 56px)',
            md: 'calc(100svh - 110px)',
            lg: 'calc(100svh - 120px)',
          },
        }}
      >
        <Outlet />
      </Box>

      {/* 푸터 */}
      <Footer analyticsTrigger={analyticsTrigger} onAnalyticsOpen={() => setAnalyticsOpen(true)} />
      <AnalyticsChoice
        open={analyticsOpen}
        onClose={() => {
          setAnalyticsOpen(false);
          if (analyticsOpen) analyticsTrigger.current?.focus();
        }}
      />
    </Box>
  );
};

export default Layout;
